import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHook";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useChatDispatch = useAppDispatch;
export const useChatSelector = useAppSelector;
